import { useState, useRef } from "react";
import { Button } from "react-bootstrap";


function HelpForm() {
  const form = useRef();
  const [incidencia, setIncidencia] = useState("");
  const [nombre, setNombre] = useState("");
  const [asunto, setAsunto] = useState("");
  const handleSubmit = (event) => {
    event.preventDefault();
    alert(`Gracias. Tu incidencia se ha enviado correctamente.`);
    setNombre("");
    setAsunto("");
    setIncidencia("");

  };
  var usuario = localStorage.getItem("username");
  return (
    <form ref={form} onSubmit={handleSubmit}>
      <label>
        Introduce tu nombre:
        <input
          name="nombre"
          className="mt-2 mb-2"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          style={{ width: "100%" }}
        />
      </label>
      <label>
      Introduce el asunto:
        <input
          name="asunto"
          className="mt-2 mb-2"
          value={asunto}
          onChange={(e) => setAsunto(e.target.value)}
          style={{ width: "100%" }}
        />
      </label>
      <label>
        Introduce tu incidencia:
        <textarea
          name="message"
          className="mt-2 mb-2"
          value={incidencia}
          onChange={(e) => setIncidencia(e.target.value)}
          style={{ width: "100%" }}
        />
      </label>
      <Button
        variant="outline-primary"
        type="submit"
        className="mt-2 mb-2"
        size="md"
        style={{ width: "100%", borderColor: "#162d50", color:"#162d50" }}
      >
        Enviar{" "}
      </Button>
    </form>
  );
}

export default HelpForm;
